// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605150933/js/" + chunkId + "." + {"44":"5bd57d5b","225":"67f7ca71","481":"2f145735","486":"816a6fb5","770":"6682fcf7"}[chunkId] + ".0.17129705912557025.chunk.js";
};